import { useMemo } from 'react'

import { FormattedMessage } from 'react-intl'

import { RICH_TEXT_VALUES } from './T'

// ///////////////////////
// MARK: CONSTANTS
const EXACT_ERROR_MESSAGE_SEPARATOR = '\r\n'

// ///////////////////////
// MARK: TYPES
export interface IHelpersFormattedErrorMessageProps {
  id?: string
  values?: Record<string, React.ReactNode>
  description?: string | object | undefined
  ignoreTag?: boolean | undefined
  tagName?: React.ElementType
}

// ///////////////////////
// MARK: EXPORTS
export const FormattedErrorMessage: React.FC<IHelpersFormattedErrorMessageProps> = ({
  id,
  values,
  description,
  ignoreTag,
  tagName,
}) => {
  const message = useMemo(() => {
    if (id?.startsWith('EXACT: ')) {
      return id.slice(
        Math.max(
          0,
          id.indexOf(EXACT_ERROR_MESSAGE_SEPARATOR) + EXACT_ERROR_MESSAGE_SEPARATOR.length,
        ),
      )
    }
  }, [id])

  if (message) {
    return <>{message}</>
  }

  return (
    <FormattedMessage
      id={id ?? 'e.unknown'}
      values={{
        ...values,
        ...RICH_TEXT_VALUES,
      }}
      defaultMessage={id}
      description={description}
      ignoreTag={ignoreTag}
      tagName={tagName}
    />
  )
}
